import './App.css';
import './main.css';
import './media.css';
import AllRoutes from "./routes";

function App() {
  return (
    <AllRoutes />
  );
}

export default App;
